module.exports = __webpack_public_path__ + "static/media/blog1.d8f4a50f.png";